import { render, staticRenderFns } from "./SimSettingsDialog.vue?vue&type=template&id=5b35b0d4&scoped=true"
import script from "./SimSettingsDialog.vue?vue&type=script&lang=js"
export * from "./SimSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./SimSettingsDialog.vue?vue&type=style&index=0&id=5b35b0d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b35b0d4",
  null
  
)

export default component.exports